interface Props {
  size?: number;
  color?: string;
}

const LeftRightIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7441 3.24408C13.0695 2.91864 13.5971 2.91864 13.9226 3.24408L18.6381 7.95956C19.268 8.58953 18.8218 9.66667 17.931 9.66667H1.66665C1.20641 9.66667 0.833313 9.29358 0.833313 8.83333C0.833313 8.3731 1.20641 8 1.66665 8H16.3215L12.7441 4.42259C12.4186 4.09715 12.4186 3.56952 12.7441 3.24408ZM3.67849 13H18.3333C18.7936 13 19.1666 12.6269 19.1666 12.1667C19.1666 11.7064 18.7936 11.3333 18.3333 11.3333H2.06901C1.17811 11.3333 0.731942 12.4105 1.3619 13.0404L6.07739 17.7559C6.40283 18.0813 6.93046 18.0813 7.2559 17.7559C7.58134 17.4305 7.58134 16.9028 7.2559 16.5774L3.67849 13Z"
        fill={color}
      />
    </svg>
  );
};

export default LeftRightIcon;
